import React from 'react'

//import Congrats from './congrats.svg'
import congrats from '../../assets/congrats.jpg'

export const FinalPage = ({isAssessed}) => {
    return (
              <img className="d-block w-100" src={congrats} alt="Congradulations" />
    )
}